import React, { useEffect, useState } from 'react';
import { ethers } from 'ethers';
import { contractABI, contractAddress } from '../utils/constants';

export const FactContext = React.createContext();

const { ethereum } = window;

const getEthereumContract = () => {
    const provider = new ethers.providers.Web3Provider(ethereum);
    const signer = provider.getSigner();
    const factContract = new ethers.Contract(contractAddress, contractABI, signer);

    return factContract;
}

export const FactProvider = ({ children }) => {
    const [currentAccount, setCurrentAccount] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [transactionHash, setTransactionHash] = useState('');
    const [isOwner, setIsOwner] = useState(false);

    const checkIfWalletIsConnected = async () => {
        if(!ethereum) return alert("Please install MetaMask");

        const accounts = await ethereum.request({ method: 'eth_accounts' });

        if(accounts.length) {
            setCurrentAccount(accounts[0]);
        } else {
            console.log("No accounts found");
        }

        console.log('%c Accounts ',
            'color: white; background-color: #F5C344',
            `Accounts: ${accounts}`);
    }

    const connectWallet = async () => {
        try {
            if(!ethereum) return alert("Please install MetaMask");

            const accounts = await ethereum.request({ method: 'eth_requestAccounts' });
            const chain = await getChain();

            if(chain != "0x4") {
                await ethereum.request({ 
                    method: 'wallet_switchEthereumChain', 
                    params: [{ chainId: '0x4' }] });
            }

            setCurrentAccount(accounts[0]);
        } catch (error) {
            console.log(error);

            throw new Error("No ethereum object.");
        }
    }

    const getChain = async () => {
        try {
            if(!ethereum) return alert("Please install MetaMask");

            return await ethereum.request({ method: 'eth_chainId' });           
        } catch (error) {
            console.log(error);

            throw new Error("No ethereum object.");
        }
    }

    const getFact = async () => {
        try {
            if(!ethereum) return alert("Please install MetaMask");
            const factContract = getEthereumContract();
            let overrides = {
                value: ethers.utils.parseEther("0.01")
            };

            const transaction = await factContract.generateFact(overrides);

            setIsLoading(true);
            setTransactionHash(transaction.hash)

            await transaction.wait();
            setIsLoading(false);
        } catch (error) {
            console.log(error);

            throw new Error("No ethereum object.");
        }
    }

    const isWalletOwner = async () => {
        try {
            if(!ethereum) return alert("Please install MetaMask");
            const factContract = getEthereumContract();
            const isOwner = await factContract.isWalletOwner();

            console.log('isOwner: ', isOwner);
            setIsOwner(isOwner);
        } catch (error) {
            console.log(error);
            throw new Error("No ethereum object.");
        }
    }

    const listener = block => {
        console.log('%c Event ',
            'color: white; background-color: #2274A5',
            `New Fact Generated: ${block}`);
    }

    useEffect(() => {
        checkIfWalletIsConnected();
        let factContract = getEthereumContract();

        factContract.on("MintFact", listener);
    }, [])

    return (
        <FactContext.Provider value={{ connectWallet, getFact, currentAccount, isLoading, transactionHash, isOwner, isWalletOwner }}>
            {children}
        </FactContext.Provider>
    )
}